import { createContext } from 'react';

import { Context } from '../../../types';
import { BankAccount } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<BankAccount>>(getContextDefaultValues(api));
